import { Component, Inject } from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";

@Component({
  selector: "view-gis360-renewal-history",
  template: require('./view-gis360-renewal-history.component.html'),
})
export class ViewGIS360RenewalHistoryComponent {
  dialogTitle = "";
  errorMessage = "";
  isLoading = false;
  // License Key row of the expanded panel [LicenseKeyId for the API, LicenseKey for the title]
  selectedSubRow;
  renewalHistory = [];

  constructor(
    private dialogRef: MdDialogRef<ViewGIS360RenewalHistoryComponent>,
    private licenseService: LicenseService,
    private adalService: AdalService,
    private router: Router,
    @Inject(MD_DIALOG_DATA) public dialogData: any,
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.dialogTitle = this.dialogData.dialogTitle;
    this.selectedSubRow = this.dialogData.SelectedSubRow;
    this.getRenewalHistory();
  }

  getRenewalHistory() {
    this.isLoading = true;
    this.licenseService.getGIS360RenewalHistory(this.selectedSubRow.LicenseKeyId).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.renewalHistory = data.DataObject;
          this.errorMessage = this.renewalHistory.length == 0 ? "No renewal history found." : "";
        } else {
          this.errorMessage = data.Error;
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.errorMessage = "Something went wrong.";
      },
    );
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/gis360/popup/view-gis360-renewal-history/view-gis360-renewal-history.component.ts